import styled from 'styled-components';

import { Text } from '@/nova/components';
import { cardHover } from '@/nova/theme/configurator-keyframes';
import { CFG } from '../../../../../../theme/configurator-tokens';
import { FINISH, FINISH_GRADIENTS, FINISH_PREVIEW } from '../../finish.tokens';

/** Phone-column width used for the mobile preview. */
export const MOBILE_W = 390;

export const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  /* The host layer this portals into is click-through; re-enable events here so the
     backdrop can take the click-outside-to-close and host the chrome. */
  pointer-events: auto;
  background-image: ${FINISH_GRADIENTS.previewBackdrop};
  backdrop-filter: blur(8px);
`;

export const Popup = styled.div`
  position: absolute;
  inset: 16px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 20px;
  background: ${FINISH.successBg};
  box-shadow: ${FINISH.previewPopupShadow};
`;

export const TopBar = styled.div`
  position: relative;
  display: flex;
  height: 64px;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  background: ${FINISH_PREVIEW.topBar};
  padding: 0 24px;
`;

export const SwitcherSlot = styled.div`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

export const CloseButton = styled.button`
  cursor: pointer;
  /* Cursor-following hover glow + lit hairline ring (shared with the CTA Button). */
  ${cardHover}
  border: none;
  border-radius: 9999px;
  background: ${CFG.brand};
  padding: 8px 16px;
  font-size: 14px;
  font-weight: 500;
  color: ${FINISH.payButtonText};
  transition: opacity 150ms ease;

  &:hover {
    opacity: 0.9;
  }
`;

export const CloseLabel = styled(Text)`
  display: inline;
`;

export const Body = styled.div`
  display: flex;
  min-height: 0;
  flex: 1;
  justify-content: center;
  overflow: hidden;
`;

/** Sized full-screen anchor box (full-width desktop / centred phone column). The host
 *  floats the bare warm iframe over this; the framed site hides its own scrollbar (nsc). */
export const Clip = styled.div<{ $mobile?: boolean }>`
  position: relative;
  height: 100%;
  overflow: hidden;
  width: ${({ $mobile }) => ($mobile ? `${MOBILE_W}px` : '100%')};
`;
